module.exports = __webpack_public_path__ + "img/email_code.c09bacde.png";